// COPY de apps/desktop/src/features/auth/leddoSubdomain.ts — apps não
// compartilham código; manter os dois em sincronia manualmente.
//
// Validação do workspace Leddo (label RFC-1123) espelhando o backend
// (apps/backend/.../domain/tenants/leddo_subdomain.py). Mantê-los em sincronia.
const LEDDO_SUBDOMAIN_RE = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/;

const STORAGE_KEY = 'copilot.leddo_workspace';

export function normalizeLeddoSubdomain(value: string): string {
  return value.trim().toLowerCase();
}

export function isValidLeddoSubdomain(value: string): boolean {
  return LEDDO_SUBDOMAIN_RE.test(value);
}

export function loadSavedWorkspace(): string {
  return localStorage.getItem(STORAGE_KEY) ?? '';
}

export function saveWorkspace(value: string): void {
  localStorage.setItem(STORAGE_KEY, value);
}
